import { ParticipantStatusEnum } from "enums/ParticipantStatusEnum";
import { createLogger } from "logging";
import { ParticipantDetailModel } from "models/ParticipantDetailModel";
import { PatchParticipantModel } from "models/PatchParticipantModel";
import { UserModel } from "models/UserModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

const logger = createLogger("EditParticipantContext");

export interface ParticipantFieldValues {
  user: UserModel | undefined;
  role: string;
  status: ParticipantStatusEnum;
  remarks: string;
  canSeeConfidential: boolean;
}

export function getParticipantFieldValues(participant?: ParticipantDetailModel): ParticipantFieldValues {
  if (!participant) {
    return {} as ParticipantFieldValues;
  }

  const user = participant.user;
  const role = participant.role || "";
  const status = participant.isDeleted ? ParticipantStatusEnum.Deleted : participant.status;
  const remarks = participant.remarks || "";
  const canSeeConfidential = participant.canSeeConfidential || false;

  const values = {
    user,
    role,
    status,
    remarks,
    canSeeConfidential,
  };
  logger.debug(`getParticipantFieldValues(): `, values);
  return values;
}

export interface EditParticipantContextProps {
  confirmParticipantUnsaved: boolean;
  setConfirmParticipantUnsaved: (newState: boolean) => void;
  editParticipantId: number;
  setEditParticipantId: (id: number) => void;
  isLoading: boolean;
  isDirty: boolean;
  isValid: boolean;
  isSubmittable: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<ParticipantFieldValues>;
  getPatch: (values: ParticipantFieldValues) => PatchParticipantModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
}

export const EditParticipantContext = createContext({} as EditParticipantContextProps);
